import React from "react"
import {DepositProduct} from "../../resources/depositProduct"
import {Resource} from "../../resources/common"
import {AllowedDepositProductsColumns} from "./DepositProducts.types"
import {Meta} from "../../resources/common"
import {DataTable, DataTableHead, DataTableBody, DataTableCell, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import DepositProductRow from "./DepositProductRow"

interface DepositProductsTableProps {
	depositProducts: DepositProduct[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedDepositProductsColumns[]
	meta?: Meta
	refresh?: () => void
	fullHeight?: boolean
}

export function DepositProductsTable({
	depositProducts,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	meta,
	prev,
	next,
	include,
}: DepositProductsTableProps) {
	const noContent = depositProducts.length === 0
	return (
		<div className={"deposit-products-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText={"No deposit products found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{depositProducts.map((p) => (
						<DepositProductRow key={p.id} include={include} includedColumns={includedColumns} depositProduct={p} />
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
